import { AvailableDeliveryMethodsDetail } from "interfaces/session/ShoppingCart";
import { IGetProductDeliveryDetailsAction } from "../interfaces/utils.interface";
export function setProductDeliveryDetails(deliveryDetails: AvailableDeliveryMethodsDetail[] | null): IGetProductDeliveryDetailsAction {
  return {
    type: "SET_PRODUCT_DELIVERY_DETAILS",
    data: deliveryDetails,
  };
}
